export default function generer() {
  return {
    adresse1: null,
    adresse2: null,
    adresse3: null,
    pays: null,
    ville: null,
    codePostal: null,
    departement: null,
    agglomeration: null,
    intitule1: null,
    intitule2: null,
    intitule3: null,
    latitude: null,
    longitude: null,
  };
}
